import { Injectable, Inject } from '@angular/core';
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { BaseService } from './BaseService';
import { IAdminPlacement } from '../Models/IAdminPlacement';

@Injectable()
export class AdminPlacementService extends BaseService {
  _baseUrl: string = "";


  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getAdminPlacement(id: number) {
    return this._http.get(this._baseUrl + "api/AdminPlacement/" + id)
      .map((response: IAdminPlacement) => response as IAdminPlacement)
      .catch(this.errorHandler);
  }

  insertUpdateAdminPlacement(adminPlacementDetails: IAdminPlacement) {
    return this._http.post(this._baseUrl + 'api/AdminPlacement', adminPlacementDetails)
      .map((response: IAdminPlacement) => response as IAdminPlacement)
      .catch(this.errorHandler);
  }

  validateAdministrativePlacement(id: number) {
    return this._http.get(this._baseUrl + "api/AdminPlacement/ValidateAdministrativePlacement" + id)
      .map((response: string[]) => response as string[])
      .catch(this.errorHandler)
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }

}
